import FireStoreParser from 'firestore-parser';
import MatchesToday from '../components/MatchesToday';
import { useEffect, useState } from "react";
import axios from 'axios';

export default function TodaysMatches({endpointUrl}) {
  const [matches, setMatches] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios.get(endpointUrl + 'data-endpoint/current-matches')
    .then(response => {
      const parsedMatches = response.data.documents.map( (match) => {
        if (match === null || match.fields === undefined) {
            return null;
        }
        const today = new Date();
        var parsed = FireStoreParser(match.fields);
        var date = new Date(parsed.startDate);
        if (today.toDateString() === date.toDateString()) {
            parsed.startDate = date.toLocaleTimeString('sv-SE',{ hour: "2-digit", minute: "2-digit" });
            return parsed;
        }
        return false;
      });
      if (parsedMatches) {
        let matchesByTime = [];
        parsedMatches.forEach((parsedMatch) => {
          if (parsedMatch) {
            const time = parsedMatch.startDate;
            if (!matchesByTime[time]) {
              matchesByTime[time] = [];
            }
            matchesByTime[time].push(parsedMatch);
            var timeTest = '20:30';
            if (!matchesByTime[timeTest]) {
              matchesByTime[timeTest] = [];
            }
            matchesByTime[timeTest].push(parsedMatch);
            matchesByTime[timeTest].push(parsedMatch);
            var timeTest = '20:45';
            if (!matchesByTime[timeTest]) {
              matchesByTime[timeTest] = [];
            }
            matchesByTime[timeTest].push(parsedMatch);
          }
        });
        const matchesByTimeArray = Object.keys(matchesByTime).map((time) => {
          return {
            time,
            matches: matchesByTime[time]
          };
        });
        setMatches(matchesByTimeArray);
      } else {
        setMatches([]);
      }
      setIsLoading(false);
    })
    .catch(error => {
      console.error(error);
      setIsLoading(false);
    });
  }, []);
  return (
      <>
        <MatchesToday matches={matches} isLoading={isLoading} />
      </>
  );
}
